import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import theme from "config/theme";

import Layout from "components/Layout";
import { ContentBlock, ActionBlock } from "components/Block";
import SubscribeForm from "components/SubscribeForm";
import LatestArticles from "components/LatestArticles";
import { Container } from "components/Grid";

import Hero from "templates/home-page/Hero";

export const HomePageTemplate = ({ page }) => {
  return (
    <>
      <Hero
        pb={["150px", "150px", "180px", "240px"]}
        shade="dark"
        buttonShade="primary"
        content={page.hero}
      />
      <Container bg={theme.color.paper} flexDirection="column">
        <ContentBlock flip mt="-100px" content={page.block1} shade="light" />
        <ContentBlock
          pb={["130px", "160px"]}
          maxWidth="1200px"
          content={page.block2}
        />
      </Container>
      <LatestArticles mt="-80px" content={page.blog} tag="financial-markets" />
      <ActionBlock content={page.cta} shade="light">
        <SubscribeForm m="40px auto 0" maxWidth="500px" />
      </ActionBlock>
    </>
  );
};

const HomePage = ({ data }) => {
  const { frontmatter: page } = data.allMarkdownRemark.edges[0].node;

  return (
    <Layout page={page} headerShade="light" shade="dark" footerShade="dark">
      <HomePageTemplate page={page} />
    </Layout>
  );
};

HomePage.propTypes = {
  data: PropTypes.object.isRequired
};

export default HomePage;

export const homePageQuery = graphql`
  query HomePage {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "home-page" } } }
    ) {
      edges {
        node {
          frontmatter {
            page {
              title
            }
            hero {
              heading
              subheading
              buttonText
              buttonPath
              image {
                childImageSharp {
                  fluid(maxWidth: 1000, quality: 100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
            block1 {
              title
              heading
              text
              buttonText
              buttonPath
              image {
                childImageSharp {
                  fluid(maxWidth: 1000, quality: 100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
            block2 {
              title
              heading
              text
              buttonText
              buttonPath
              image {
                childImageSharp {
                  fluid(maxWidth: 800, quality: 100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
            blog {
              heading
            }
            cta {
              heading
              subheading
              buttonText
              buttonPath
            }
          }
        }
      }
    }
  }
`;
